import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { vocabularyCodes } from '@/vocabularies/constants';
import { getCountType } from '@/metrics/helper';
import availableRoleActions from '@/roles/roleactions/helper';

const useHomeBanner = () => useSelector(({
  auth: { commonsMode, currentUser: { isGuest }, role: { permissions: { datasets: { read }, search: { run } } } },
  metrics,
  vocabularies: { vocabularies },
}) => {
  const heading = findResult(vocabularies, 'all', vocabularyCodes.LANDING_PAGE_BANNER);
  const count = getCountType(metrics, isGuest, commonsMode);

  return {
    allowDatasetsSearch: read && run,
    count,
    heading: heading?.value,
    readStatus: metrics.readStatus,
  };
});

const useHomePanelLaunchers = () => useSelector(({
  auth: { users: { open: { roleActions: { results } } } },
  vocabularies: { vocabularies },
}) => {
  const { roleActions } = findResult(vocabularies, 'all', vocabularyCodes.ROLE_ACTIONS);
  return { launchers: availableRoleActions(roleActions, results, ({ name }) => name) };
});

export default {
  useHomeBanner,
  useHomePanelLaunchers,
};
